import { IInputErrorProps } from "./interface";
import styles from "./styles";

const InputError: React.FC<IInputErrorProps> = ({ text }: IInputErrorProps) => {
  return <styles.InputErrorWrapper>{text}</styles.InputErrorWrapper>;
};

export default InputError;
